const staticFeatureFlags = {
  "fe.constructor.duplicate-block-button": true,
  "fe.blocks.profile_info_response_type": true,
  "fe.blocks.race-cond-fix": true,
  "fe.blocks.form_block": true,
  "fe.constructor.project-creation-status": true,
  "fe.blocks.default_dimension_values": true,
  "fe.blocks.elements_tab_tabs": true,
  "fe.host.enable_b2b_ac_auth": true,
  "fe.blocks.elements_tab_dropdown_button": true,
  "fe.blocks.language_list": true,
  "fe.blocks.fix_ar_language": true,
  "fe.constructor.create-scenario-close-modal": true,
  "fe.blocks.custom-modal-settings": true,
  "fe.constructor.add_scroll_to_action": true,
  "fe.blocks.shadow_dom_aware_click_outside": true,
  "fe.constructor.add_up_button_scenario": true,
  "fe.blocks.css_generation_from_config": true,
  "fe.blocks.open-graph": true,
  "fe.block.edit_menu_item": true,
  "fe.constructor.create-auth-header-scenarios": true,
  "fe.blocks.remove_sweep_stake_widget_client_id": true,
  "fe.blocks.zero_item_size": true,
  "fe.constructor.create-buttons-scenarios": true,
  "fe.constructor.track_event": true,
  "fe.constructor.create-personal-profile-scenarios": true,
  "fe.blocks.hidden_block_styles": true,
  "fe.blocks.auth_pages_button_settings": true,
  "fe.blocks.default_font_values": true,
  "fe.blocks.changed_offset_position_modal": true,
  "fe.blocks.form_wrapper": true,
  "fe.blocks.auth_font_size": true,
  "fe.blocks.button_library_defaults": true
};

export default staticFeatureFlags;